<script lang="ts">
  import { onexVariantByToggle } from "@otto-ec/global-resources/onex";
  import { useHost } from "../../../common/runtime/utils/useHost.ts";

  let Host = useHost();

  let { size } = $props();

  let ghostLabel = $state("");

  const onslotchange = (): void => {
    let children = Array.from(Host.children).filter((e): e is HTMLElement => e.slot === "content");

    if (children.length === 0) {
      children = Array.from(Host.children).filter((e): e is HTMLElement => e.slot === "");
    }
    ghostLabel = children.map((e) => e.innerText).join(" ");
  };

  const isOnexNewOutline = onexVariantByToggle("oc_onex_chip_checked_state", "newOutline", {
    variants: ["newOutline"],
  });

  $effect(() => {
    Host.classList.toggle("oc-onex-chip-checked-state-new-outline", $isOnexNewOutline.value);
  });

  onslotchange();
</script>

<svelte:element this={"slot"} {onslotchange}></svelte:element>
<slot name="image"></slot>
<div data-label={ghostLabel} class={`s${size}`}></div>
<svelte:element this={"slot"} name="content" {onslotchange}></svelte:element>

<style lang="scss">
  @use "@otto-ec/design-tokens/component" as tokens;

  [data-label]:not([data-label=""]) {
    grid-area: 1 / 3;
    display: inline-block;
    position: relative;
    &.s200::after {
      margin-inline: #{tokens.$oc-component-chip-200-text-spacing-x};
    }
  }
  [data-label]::after {
    content: attr(data-label);
    display: block;
    font-weight: #{tokens.$oc-component-chip-checked-font-weight};
    text-align: left;
    white-space: pre-line;
    height: 0;
    visibility: hidden;
  }
</style>
